import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../../routes';
// Custom components
import { SignOutBtn } from '../Buttons'
// Material Components
import {
    SwipeableDrawer,
    List, ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    Divider
} from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';
// Styles
import { flex } from '../../assets/jss';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    list: {
        width: 250,
        ...flex.flex_column_center,
        padding: '0px 5px'
    },
    menuIcon: {
        color: 'white'
    },
    link: {
        textDecoration: 'none',
        color: 'black',
        textAlign: 'left',
        width: '100%'
    }
});

const items = ['Recent Stories', 'Home', 'Gallery', 'Settings'];

export default function SwipeableTemporaryDrawer() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (value) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(value);
    };

    return (
        <div>
            <React.Fragment>
                <IconButton onClick={toggleDrawer(true)}>
                    <MenuIcon className={classes.menuIcon} />
                </IconButton>

                <SwipeableDrawer
                    anchor={'left'}
                    open={open}
                    onClose={toggleDrawer(false)}
                    onOpen={toggleDrawer(true)}
                >
                    <List className={classes.list}>
                        <br />
                        <Divider />
                        {routes.map((route, i) =>
                            //eslint-disable-next-line
                            items.map(item => {
                                if (route.text === item) {
                                    return (
                                        <Link key={i} className={classes.link} to={route.path}>
                                            <ListItem button>
                                                <ListItemIcon>
                                                    <route.icon />
                                                </ListItemIcon>
                                                <ListItemText primary={route.text} />
                                            </ListItem>
                                        </Link>
                                    )
                                }
                            })
                        )}

                        <SignOutBtn />
                    </List>
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    );
}
